/// <reference path="../../app.definition.ts" />

import { Serializable } from "./Serializable";

export class CachedItem implements Serializable<CachedItem> {
    lastValidTime: number;
    lastAccessed: number;
    static TIMEOUT_MINUTES: number = 5;

    constructor() {
        this.lastValidTime = new Date().getTime();
        this.lastAccessed = this.lastValidTime;
    }

    deserialize(input: any): CachedItem {
        !!input.lastValidTime && (this.lastValidTime = input.lastValidTime)
        !!input.lastAccessed && (this.lastAccessed = input.lastAccessed)
        return this;
    }

    update(updateItem: any): CachedItem {
        this.lastValidTime = new Date().getTime();
        this.deserialize(updateItem);
        return this;
    }

    access(): CachedItem {
        this.lastAccessed = new Date().getTime();
        return this;
    }

    isValidByTime(): boolean {
        let date = new Date();
        let delta = date.getTime() - this.lastValidTime;
        // console.log("Checking validity of cached item:", date.getTime(), "-", this.lastValidTime, '=', delta, '('+(delta/60/1000)+')');
        return (date.getTime() - this.lastValidTime < (3 * 60 * 1000));
    }
}
